import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { PageRolesService } from '../../Service/page-roles.service';
import { ChildrenKeyPair, Page, RoleVm } from '../../Model/pageRoles';
import { FileVm } from '../../../../shared/Models/fileVm';
import { uploadService } from '../../../../shared/uploadService';
import { combineLatest, Observable, of } from 'rxjs';
import { catchError, expand, switchMap, tap } from 'rxjs/operators';
import { PagingModel } from '../../../../shared/Models/PagingModel';
import { RolesService } from '../../../roles/services/roles-service';
import { QueryModel } from '../../../../shared/Models/queryModel';

@Component({
  selector: 'add-page-roles',
  templateUrl: './add-page-roles.component.html',
  styleUrls: ['./add-page-roles.component.scss']
})
export class AddPageRolesComponent implements OnInit {

  models: Page[] = [] as Page[];
  model: Page = {  } as Page;
  isEdit = false;
  get pageType(): string {
    if(this.model.parentId == null)
    {
    return this.model.expanded ? 'نعم' : 'لا';
    }
    else
    {
      return this.isChildrenPage ? 'نعم' : 'لا';
    }

  }
  isChildrenPage: boolean = false;
  allParentPages: Page[] = [];
  childInvalid = false;
  formData: FormData = new FormData();
  isLoading: boolean = false;
  newTag: string = '';
  newTagEN: string = '';
  uploadThumbnail = false;
  childrens: Page[] = [] as Page[];
  roles: RoleVm[] = [] as RoleVm[];
  allChildren: Page[] = [];
  allRoles: RoleVm[] = [];
  pagingModel: PagingModel;
  private validPhoto: boolean = true;
  private newPhotoUploaded = false;
  private imagePath: string;
  private imgURL: any;
  private file: any;
  private fileName: string;
  private Image: FileVm;
  constructor(
    private route: Router,
    public diagRef: NbDialogRef<AddPageRolesComponent>,
    public service: PageRolesService,
    public rolesService: RolesService,
    public toast: NbToastrService,
    private uploadservice: uploadService
  ) {
    this.pagingModel = new PagingModel();
  }

  ngOnInit() {
    this.route.events.subscribe(() => {
      this.diagRef.close('false');
    });
    this.service.get({
      currentPage: 1,
      pageSize: 100,
      searchTerm: '',
      sort: 'Id',
      sortDirection: 'des'
    } as QueryModel).subscribe((res) => {
      res.result.forEach(item => {
        if (item.parentId != null) {
          this.allChildren.push({
            id: item.id,
            title: item.title,
            link: item.link,
            order: item.order,
            icon: item.icon,
            parentId: item.parentId,
            children: [],
            roles: item.roles,
            expanded: false
          } as Page);
        }
        else
        {
          this.allParentPages.push({
            id: item.id,
            title: item.title,
            link: item.link,
            order: item.order,
            icon: item.icon,
            parentId: item.parentId,
            children: [],
            roles: item.roles,
            expanded: false
          } as Page);
        }
      }
      );
    });

    this.rolesService.get({
      currentPage: 1,
      pageSize: 100,
      searchTerm: '',
      sort: 'Id',
      sortDirection: 'des'
    } as QueryModel).subscribe((res) => {
      this.allRoles = res.result;
      this.model.rolesId = this.model.roles.map(role => role.id);
    });

    // if (this.model.icon) {
    //   if (this.model.icon != '') {
    //     this.uploadThumbnail = true;
    //     this.validPhoto = true;
    //   } else {
    //     this.uploadThumbnail = false;
    //     this.validPhoto = false;
    //   }
    // }



  }

  close() {
    this.diagRef.close();
  }

  childSelected() {
    this.childInvalid = false;
  }

  isAttachementsValid(): boolean {
    if (!this.uploadservice.isFilesEmpty() || !this.uploadservice.isPrevAttachementsEmpty()) return true;

    return false;
  }

  removePhoot() {
    this.uploadThumbnail = true;
    this.validPhoto = false;
  }


  getFormData(event) {
    this.formData = event;
    if (event) this.validPhoto = true;
  }

  mapPagesVmToPages() {
    this.model.children = this.childrens;
  }

  saveEntity(model): Observable<any> {
    return this.service.post(model);
  }

  update() {
    this.isLoading = true;
    // Check if formData is empty using forEach
    let isFormDataEmpty = true;
    this.formData.forEach(() => {
      isFormDataEmpty = false;
    });
    const attachment$ = !isFormDataEmpty ? this.uploadservice.uploadImage(this.formData) : of(null);
    if (this.childrens && this.childrens.length > 0) {
      this.model.children = this.childrens;
    }
    if (this.roles && this.roles.length > 0) {
      this.model.roles = this.roles;
    }
    if(!this.model.expanded)
    {
      this.model.children=[];
    }
    combineLatest([attachment$])
      .pipe(
        switchMap(([img]) => {
          if (img && img.fileName) {
            this.model.icon = img && img.fileName ? img.fileName : undefined;
          }
          return this.service.put(this.model.id, this.model);
        })
      )
      .subscribe({
        next: (res) => {
          this.isLoading = false;
          this.diagRef.close('true');
          this.toast.show('تم تعديل الصفحة بنجاح', '', { status: 'success', duration: 3000 });
        },
        error: (err) => {
          this.diagRef.close('true');
          this.toast.danger('خطأ في تعديل الصفحة ', 'خطأ', { status: 'success', duration: 3000 });
        },
      });
  }
}






